import { Box, Stack, Text } from '@stitch-fix/mode-react';
import { TopItemEndCardFragment } from '../../../utils/hooks/getTopItems';
type TopItemEndCardProps = {
  endCard: TopItemEndCardFragment;
};

/**
 * TopItemEndCard renders the styling for the endCard for the TopItemCarousel
 */
export const TopItemEndCard = ({
  endCard
}: TopItemEndCardProps) => {
  return <Box width="168px" height="213px" mt="1px" bgColor="gray-99" p={1} style={{
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
      <Stack spacing={0.75} hAlign="center">
        <Text height="standard" scale="1" align="center" setting="title-xsmall">
          {endCard.heading}
        </Text>
        <Text height="short" scale="1" align="center" setting="subtitle-small" family="medium">
          {endCard.subheading}
        </Text>
      </Stack>
    </Box>;
};